import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  InputBase,
} from "@mui/material";
import SingleChatScreen1 from "../SingleChat/index1";
import { CaseListType } from "../../../../../DataTypes/Case.type";
import CaseApi from "Service/Case.api";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { FormateCaseList } from "./Formatter";
import ImgPath from "Constants/Imgs";
import DateTime from "Utils/DateTime";
import { disconnectChatHub } from "Service/signalRService";
import NoData from "Components/NoData";
import Loader from "Components/Loader";
import { useMediaQuery, useTheme } from "@mui/material";
import ChatListComponent from "./ChatListComponent";
import ChatWindowComponent from "./ChatWindow";
import { useLocation } from "react-router-dom";

const WhatsAppChatListLayout = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedCase, setSelectedCase] = useState<null | CaseListType>(null);
  const [showChatList, setShowChatList] = useState(true);
  const [allCases, setAllCases] = useState<CaseListType[]>([]);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  // Effect to watch for notification ID or auto-select single/filtered case once list is available
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paramId = searchParams.get("openCase");
    const stateId = location.state?.openCaseId;
    const targetId = paramId || stateId;

    if (targetId && allCases.length > 0) {
      const targetCaseObject = allCases.find((c) => c.caseId === Number(targetId));
      if (targetCaseObject) {
        setSelectedCase(targetCaseObject);
        if (isMobile) setShowChatList(false);
      }
    } else if (!targetId && allCases.length > 0 && !selectedCase) {
      // Auto-select the first case if single case exists or filtered from dashboard (e.g., Active Orders)
      if (allCases.length === 1 || location.state?.paymentStatus || location.pathname.includes("admin-support")) {
        setSelectedCase(allCases[0]);
        if (isMobile) setShowChatList(false);
      }
    }
  }, [location.state, location.search, allCases, location.pathname, myInfo]);


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        flex: 1,
        height: "100%",
        minHeight: 0,
        backgroundColor: "#f0f7ff",
        overflow: "hidden",
      }}
    >
      {isMobile ? (
        showChatList ? (
          <ChatListComponent
            selectedCase={selectedCase}
            setShowChatList={(value: boolean) => setShowChatList(value)}
            getSelectedCase={(caseData: CaseListType) =>
              setSelectedCase(caseData)
            }
            onListLoaded={(list: CaseListType[]) => setAllCases(list)}
          />
        ) : (
          <ChatWindowComponent selectedCase={selectedCase} setShowChatList={setShowChatList} />
        )
      ) : (
        <>
          <ChatListComponent
            selectedCase={selectedCase}
            setShowChatList={(value: boolean) => setShowChatList(value)}
            getSelectedCase={(caseData: CaseListType) =>
              setSelectedCase(caseData)
            }
            onListLoaded={(list: CaseListType[]) => setAllCases(list)}
          />
          <ChatWindowComponent selectedCase={selectedCase} setShowChatList={setShowChatList} />
        </>
      )}
    </Box>
  );
};

export default WhatsAppChatListLayout;
